import caseStudy1 from "../assets/images/CaseStudyCard/Market entry.png";
import caseStudy2 from "../assets/images/CaseStudyCard/Push and Pull.png";
import caseStudy3 from "../assets/images/CaseStudyCard/Crystal ball forecasting.png";

export const caseStudiesData = [
    {
        id: 1,
        image: caseStudy3,
        title: "Crystal Ball Forecasting",
        description: "In a competitive and uncertain business environment, staying ahead means accurately predicting what's next...",
        link: "/casestudydetails/1"
    },
    {
        id: 2,
        image: caseStudy1,
        title: "Breaking New Ground: Market Entry Strategy",
        description: "Winning in a new market isn’t just luck — it is planning and strategy. Inteliphyle helped a multinational client cut through complexity...",
        link: "/casestudydetails/2"
    },
    {
        id: 3,
        image: caseStudy2,
        title: "Driving Brand Growth through Pull and Push Actions",
        description: "Brand growth requires a 360-degree push and pull strategy driven by marketing activities to create retailer and consumer interest...",
        link: "/casestudydetails/3"
    }, 
]; 